import { CHARITY_ROLES } from '@/constants/roles'

/**
 * Angular `staff-list.component.html` Action column visibility:
 * `accessibleMenu.user_management` includes Write, excluding property agent / charity roles,
 * and hidden for property admin/manager when the staff list is loaded with `companyId` (company edit context).
 */
export function shouldShowStaffListActionColumn(
  roleName: string,
  hasUserManagementWrite: boolean,
  staffListCompanyId: string | number | null | undefined,
): boolean {
  if (!hasUserManagementWrite) return false
  if (roleName === 'ROLE_PROPERTY_AGENT') return false
  if ((CHARITY_ROLES as readonly string[]).includes(roleName)) return false
  const companyScoped = staffListCompanyId != null && String(staffListCompanyId).trim() !== ''
  if (
    companyScoped &&
    (roleName === 'ROLE_PROPERTY_ADMIN' || roleName === 'ROLE_PROPERTY_MANAGER')
  ) {
    return false
  }
  return true
}
